import { getters } from "@/constants/state";

export default {
  [getters.HORECA_LOCATIONS_GETTER]: (state) => state.horecaLocations,
};
